export enum PopDiffPrefix {
	DELTA = 'delta_',
	HISTORIC = 'period_2_',
	PERCENT_CHANGE = 'percentChange_',
	P_VALUE = 'pValue_',
	SIGNIFICANCE = 'significance_'
}
